module.exports = __webpack_public_path__ + "assets/exponea.f0e3a63a.svg";